export class CreativeSortField {
    static readonly Publisher: number = 1;
    static readonly Name: number = 2;
    static readonly StartDate: number = 3;
    static readonly EndDate: number = 4;
    static readonly Position: number = 5;
    static readonly ProcessingStatus: number = 6;
    static readonly Provider: number = 7;
}


// WEBPACK FOOTER //
// ./src/app/creatives/creative-sort.enum.ts